module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v(_vm._s(_vm.auth.authenticated() ? 'logout' : 'login'))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/projects"
    }
  }, [_vm._v("projects")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/create"
    }
  }, [_vm._v("create project")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-2299b399"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 125
// module chunks = 1